import type { CodeConfirmData, CodeError } from 'src/widgets/CodeConfirmation';

export type AuthorizationData = {
  shake: boolean;
  errorMessage: boolean;
  isEmptyField: boolean;
  showFieldError: boolean;
  loginDataChecked: boolean;
  phone: string;
};

export type RegistrationData = CodeConfirmData & {
  type: string;
  sessionToken: string | null;
  phoneToken: string | null;
  disabled: boolean;
  checked: boolean;
  completed: boolean;
  newPassword: string;
  regStep: number;
  codeError: CodeError | null;
};

export type PassFormValues = {
  newPass: string;
  login: string;
};

export enum Step {
  INITIAL = 1,
  CODE,
  PASSWORD,
}
